import { motion } from "framer-motion";

export const EASE = [0.76, 0, 0.24, 1];

export const MaskedLine = ({ children, delay = 0, className = "" }) => (
  <div className="overflow-hidden">
    <motion.div
      initial={{ y: "115%" }}
      animate={{ y: "0%" }}
      transition={{ duration: 1.2, ease: EASE, delay }}
      className={className}
    >
      {children}
    </motion.div>
  </div>
);

export const Reveal = ({ children, delay = 0, y = 48, className = "" }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 1, ease: EASE, delay }}
    className={className}
  >
    {children}
  </motion.div>
);
